/**
 * KA-49 §5 — TRANG THỐNG KÊ NĂNG LƯỢNG: phần THUẦN (không React — `kiem-ka49` nhập thẳng).
 *
 * 🔴 Luật số 0: ngày thiếu số là null — tổng chỉ cộng ngày CÓ số và nói ra "x / N ngày có số"; so sánh chỉ khi CẢ HAI vế có số.
 * ⛔ "Tiết kiệm nhờ dim (ước tính)" CHỈ khi máy chủ tính được từ dữ liệu thật (đèn có P lúc 100 % ĐO được — `nangLuongDen.ts`);
 *   không đèn nào tính được ⇒ ô thứ 5 thay bằng "Số ngày có số đo". Không bịa từ công suất định mức.
 */

export interface DenNL {
  cabinetId: string; addr: number; ten: string; rated_w: number | null; src: number | null; pNay: number | null;
  ngay: (number | null)[]; tkNgay: (number | null)[]; kwh: number | null; tietKiemKwh: number | null; dimTb: number | null; p100: number | null;
}
export interface DuLieuNL {
  ngay: string[];
  tu: { id: string; name: string; routeId: string | null }[];
  den: DenNL[];
  congSuat: { tuW: number | null; soTuTinh: number; soTuChuaRoDonVi: number; denW: number | null; soDen: number };
  demQua: { tu: string; den: string; dangChay: boolean; tuW: (number | null)[]; denW: (number | null)[]; soTuChuaRoDonVi: number } | null;
}

const cong = (ds: readonly (number | null)[]) => { const v = ds.filter((x): x is number => x !== null); return v.length ? v.reduce((s, x) => s + x, 0) : null; };

/** Số cho 3 ô đầu từ chuỗi ngày (phần tử cuối = HÔM NAY). */
export function soLieuNgay(ds: readonly (number | null)[], n: number) {
  const cuoi = ds.length - 1;
  const homNay = ds[cuoi] ?? null, homQua = ds[cuoi - 1] ?? null, tuanTruoc = ds[cuoi - 8] ?? null;
  const khoang = ds.slice(-n);
  return {
    homNay, homQua, tuanTruoc,
    /** % chênh hôm qua so với cùng thứ tuần trước — chỉ khi cả hai có số và tuần trước > 0 */
    chenhPct: homQua !== null && tuanTruoc !== null && tuanTruoc > 0 ? ((homQua - tuanTruoc) / tuanTruoc) * 100 : null,
    tongN: cong(khoang), soNgayCo: khoang.filter((x) => x !== null).length, soNgay: khoang.length,
  };
}

/** Tổng theo ngày của nhiều chuỗi: ngày nào KHÔNG chuỗi nào có số ⇒ null (không 0). */
export function congTheoNgay(cacChuoi: readonly (readonly (number | null)[])[], dai: number): (number | null)[] {
  return Array.from({ length: dai }, (_, i) => cong(cacChuoi.map((c) => c[i] ?? null)));
}

/** Ô thứ 5: tiết kiệm nhờ dim của các đèn trong phạm vi — null khi KHÔNG đèn nào tính được (đổi sang "Số ngày có số đo"). */
export function tietKiemPhamVi(den: readonly DenNL[]): { kwh: number; pct: number | null; soDenTinh: number; soDen: number } | null {
  const tinh = den.filter((d) => d.tietKiemKwh !== null);
  if (!tinh.length) return null;
  const tk = tinh.reduce((s, d) => s + d.tietKiemKwh!, 0);
  const dung = cong(tinh.map((d) => d.kwh));
  return { kwh: tk, pct: dung !== null && dung + tk > 0 ? (tk / (dung + tk)) * 100 : null, soDenTinh: tinh.length, soDen: den.length };
}

/** Nhãn nguồn số liệu một dòng của bảng "Theo tủ và đèn". */
export function nguonSoLieu(loai: 'tu' | 'den', src: number | null): { nhan: string; tone: 'ngoc' | 'canh' | 'xam' } {
  if (loai === 'tu') return { nhan: 'Công tơ', tone: 'ngoc' };
  return src === 0 ? { nhan: 'Đo thật', tone: 'ngoc' } : src === 1 ? { nhan: 'Giả lập', tone: 'canh' } : { nhan: '—', tone: 'xam' };
}

/** Đuôi ngắn cho chuỗi sparkline: n phần tử cuối. */
export const duoi = <T,>(ds: readonly T[], n: number) => ds.slice(Math.max(0, ds.length - n));
